import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'search-bar.clear-label': {
    id: 'search-bar.clear-label',
    defaultMessage: 'Clear',
    description: 'The label for the search bar clear icon.'
  }
});
